import { createContext, Dispatch, useContext } from 'react';
import { CancelFlowNode } from '../types';
import { CancelFlowAction } from '../cancelFlowReducer';

export const StepContext = createContext<{
  dispatch: Dispatch<CancelFlowAction>;
  currentStep: CancelFlowNode | null;
  previousStep: CancelFlowNode | null;
  nextDefaultStep?: CancelFlowNode | null;
  flowContext: { subscriptionId: string; cancelReason?: string };
  isPreview: boolean;
} | null>(null);

export function useStepContext() {
  const context = useContext(StepContext);
  if (!context) {
    throw new Error('useStepContext must be used within StepContext.Provider');
  }
  return context;
}
